"use client";
import { makeGenericStorage } from "./genericstorage";
import Cookies from "js-cookie";
import { makeGenericStorageContext } from "../context";
/**
 * cookieStorage operations, define setter, getter and remover for this
 * storage implementation.
 */
const cookieStorageOperations = {
    getItem: (key) => {
        if (typeof window !== "undefined") {
            return Cookies.get(key);
        }
        return null;
    },
    setItem: (key, value, options) => {
        if (typeof window !== "undefined") {
            return Cookies.set(key, value || "", options);
        }
    },
    removeItem: (key, options) => {
        if (typeof window !== "undefined") {
            Cookies.remove(key, options);
        }
    },
};
const { useStorage, Provider } = makeGenericStorage("CookieStorage", cookieStorageOperations, makeGenericStorageContext);
/**
 * Return a cookieStorage store, to be used for interacting with cookieStorage.
 *
 * Usage:
 * ```
 * const cookieStorage = useCookieStorage();
 *
 * const myValue = cookieStorage.getItem("my-key");
 * ```
 *
 * @returns a cookieStorage store.
 * @public
 */
export const useCookieStorage = useStorage;
/**
 * CookieStorageProvider component.
 * This provides a CookieStorage context for your app. Note that directly using
 * this component is only needed if you are not using this via the gatsby plugin.
 *
 * Usage:
 * ```
 * function App = () => {
 *   // Use this provider to pass the
 *   // cookieStorage context to the tree below.
 *   // You can invoke `useCookieStorage` in any
 *   // of the components within.
 *   return (
 *     <CookieStorageProvider>
 *       <MyApp />
 *     </CookieStorageProvider>
 *   );
 * }
 * ```
 */
export const CookieStorageProvider = Provider;
//# sourceMappingURL=cookiestorage.js.map